import Cell1 from "./Cells/Cell1";
import Cell2 from "./Cells/Cell2";
import Cell3 from "./Cells/Cell3";
import Cell4 from "./Cells/Cell4";
import Cell5 from "./Cells/Cell5";
import Cell6 from "./Cells/Cell6";
import Cell7 from "./Cells/Cell7";
import Cell8 from "./Cells/Cell8";
import Cell9 from "./Cells/Cell9";
import Cell1Nav from "./Cells/Cell1Nav";
import Cell2Nav from "./Cells/Cell2Nav";
import Cell3Nav from "./Cells/Cell3Nav";
import Cell4Nav from "./Cells/Cell4Nav";
import Cell5Nav from "./Cells/Cell5Nav";
import Cell6Nav from "./Cells/Cell6Nav";
import Cell7Nav from "./Cells/Cell7Nav";
import Cell8Nav from "./Cells/Cell8Nav";
import Cell9Nav from "./Cells/Cell9Nav";
import colors from "./colors";

const changeColors = (svgEl) => {
  const fillGroups = svgEl.querySelectorAll(".fill-group");
  const tempColors = [...colors];
  for (let i = 0; i < fillGroups.length; i++) {
    const element = fillGroups[i];
    const usedColorIndex = Math.floor(Math.random() * tempColors.length);
    const usedColor = tempColors.splice(usedColorIndex, 1);
    element.style.fill = usedColor.pop();
  }
};

const PagesEnum = Object.freeze({ INTRO: 1, GRID: 2, SINGLE: 3, PRINT: 4 });
const cellData = Object.freeze({
  1: { element: Cell1, navElement: Cell1Nav, layers: [7, 4, 2, 6, 5, 3, 1] },
  2: { element: Cell2, navElement: Cell2Nav, layers: [4, 6, 8, 7, 2, 5, 3, 1] },
  3: { element: Cell3, navElement: Cell3Nav, layers: [4, 3, 2, 1] },
  4: { element: Cell4, navElement: Cell4Nav, layers: [2, 4, 3, 5, 1] },
  5: { element: Cell5, navElement: Cell5Nav, layers: [6, 4, 5, 3, 2, 1] },
  6: { element: Cell6, navElement: Cell6Nav, layers: [6, 5, 2, 3, 4, 7, 1] },
  7: { element: Cell7, navElement: Cell7Nav, layers: [4, 2, 3, 1, 5] },
  8: { element: Cell8, navElement: Cell8Nav, layers: [8, 6, 2, 7, 4, 5, 1, 3] },
  9: { element: Cell9, navElement: Cell9Nav, layers: [3, 2, 1] },
});

export { changeColors, PagesEnum, cellData };
